import React, { useState, useEffect } from 'react';
import styles from './FeedbackCard.module.css';

export default function FeedbackCard({ title, appLanguage }) {
  const [feedbackOptions, setFeedbackOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    // Direct localStorage reading
    const entries = JSON.parse(localStorage.getItem('ayaAppEntries') || '[]');
    const assets = JSON.parse(localStorage.getItem('ayaAppAssets') || '[]');

    // Add helper function inside useEffect  
    const getAssetUrl = (assetId, language = appLanguage || 'es-VE') => {
      const asset = assets.find(a => a.sys.id === assetId);
      if (!asset?.fields?.file) return '';
      
      // Try localized file first
      const localizedFile = asset.fields.file[language];
      if (localizedFile?.url) {
        const url = localizedFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      // Fallback to any available file
      const fallbackFile = Object.values(asset.fields.file)[0];
      if (fallbackFile?.url) {
        const url = fallbackFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      return '';
    };

    // Define hardcoded fallback translations
    const translations = {
      en: {
        happy: "Very useful",
        neutral: "Normal",
        sad: "I didn't like",
      },
      "es-US": {
        happy: "Muy útil",
        neutral: "Normal",
        sad: "No me gustó",
      }
    };
    
    const selectedLang = translations[appLanguage] || translations["es-US"]; // Default to Spanish
    
    setFeedbackOptions([
      {
        label: selectedLang.happy,
        iconBlue: getAssetUrl("6zfJzBuo2ZX8OOo9Yy3DR4") || '',
        iconRed: getAssetUrl("6WHgogMX4FlBPgWGNKGlL1") || '',
      },
      {
        label: selectedLang.neutral,
        iconBlue: getAssetUrl("XMBUllUtQdyYMf98WkSAY") || '',
        iconRed: getAssetUrl("7BVY27vwwjRXJyfmfeh6C5") || '',
      },
      {
        label: selectedLang.sad,
        iconBlue: getAssetUrl("13CmxYjsuSPjNtXHqQcGoY") || '',
        iconRed: getAssetUrl("6dz9KewFsMWN5hZJS5S4ab") || '',
      },
    ]);
  }, [appLanguage]);

  const handleFeedbackClick = (optionLabel) => {
    if (selectedOption) {
      return;
    }

    setSelectedOption(optionLabel);

    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'feedback_click', {
        event_category: 'Feedback',
        event_label: optionLabel,
        page_path: window.location.pathname,
      });
    } else {
      console.warn('Google Analytics is not available.');
    }
  };

  return (
    <div className={styles.feedbackCardContainer}>
      <div className={styles.cardTitle}>{title}</div>
      <div className={styles.iconsContainer}>
        {feedbackOptions.map((option, index) => (
          <button
            key={index}
            className={`${styles.iconCard} ${
              selectedOption === option.label ? styles.selected : ''
            }`}
            onClick={() => handleFeedbackClick(option.label)}
            aria-label={`Feedback option: ${option.label}`}
            disabled={selectedOption !== null}
          >
            <img
              src={
                selectedOption === option.label
                  ? option.iconRed 
                  : option.iconBlue
              }
              alt={option.label}
              className={styles.iconImage}
            />
            <div className={styles.iconLabel}>
              {option.label}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}